/**
 * Passwortfeld mit Auge zum Aufdecken.
 *
 * Am Tablet, mit kalten Fingern, ist ein vertipptes Passwort der haeufigste
 * Grund, warum die Anmeldung scheitert — und ohne Auge sieht man nicht, ob
 * es am Passwort lag oder am Konto. Aufgedeckt bleibt es nur, solange man
 * es will; ein zweiter Tipp verdeckt es wieder.
 */

import { useState } from 'react';

type Eingabe = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function Passwortfeld({ style, ...eingabe }: Eingabe): React.JSX.Element {
  const [sichtbar, setSichtbar] = useState(false);
  return (
    <span className="passwortfeld" style={style}>
      <input {...eingabe} type={sichtbar ? 'text' : 'password'} autoCapitalize="off" autoCorrect="off" spellCheck={false} />
      <button
        type="button"
        className="passwortfeld__auge"
        aria-label={sichtbar ? 'Passwort verbergen' : 'Passwort anzeigen'}
        aria-pressed={sichtbar}
        title={sichtbar ? 'Passwort verbergen' : 'Passwort anzeigen'}
        onClick={() => setSichtbar((s) => !s)}
      >
        {sichtbar ? (
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
            <path
              d="M3 3l18 18M10.6 10.6a2 2 0 0 0 2.8 2.8M9.9 5.2A9.8 9.8 0 0 1 12 5c5 0 9 4.5 10 7a12.7 12.7 0 0 1-3.2 4.3M6.6 6.6C4.3 8 2.7 10.2 2 12c1 2.5 5 7 10 7a9.6 9.6 0 0 0 4.4-1.1"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
            <path
              d="M2 12c1-2.5 5-7 10-7s9 4.5 10 7c-1 2.5-5 7-10 7S3 14.5 2 12z"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
          </svg>
        )}
      </button>
    </span>
  );
}
